import { render, staticRenderFns } from "./FormInputRange.vue?vue&type=template&id=5b3b497c&"
import script from "./FormInputRange.vue?vue&type=script&lang=js&"
export * from "./FormInputRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b3b497c')) {
      api.createRecord('5b3b497c', component.options)
    } else {
      api.reload('5b3b497c', component.options)
    }
    module.hot.accept("./FormInputRange.vue?vue&type=template&id=5b3b497c&", function () {
      api.rerender('5b3b497c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormInputRange.vue"
export default component.exports